import { snackActions } from '@/components/snackbarUtils/SnackbarUtils'

export const prepareHeaders = (headers: Headers) => {
  const accessToken = localStorage.getItem('accessToken')
  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`)
  }
  return headers
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleApiError = (errorText: string, error?: any) => {
  if (error?.error.status === 401) {
    localStorage.clear()
    // @ts-expect-error says it should be number but that is wrong
    history.go('/')
  } else {
    snackActions.error(errorText)
  }
}
